import React, { Fragment } from 'react';
import _ from 'lodash';
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';


class AlcoholFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.processResponse = this.processResponse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);

        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        this.state = {
            isOpen: false,

            filters: AlcoholFilter.getFiltersFromQS(
                current_qs,
                {
                    "Drinker": {
                        filter_name: "drinker",
                        active: false,
                        count: 0
                    },

                    "Heavy Drinker": {
                        filter_name: "heavy_drinker",
                        active: false,
                        count: 0
                    },

                    "Lifelong Non-Drinker": {
                        filter_name: "lifelong_non_drinker",
                        active: false,
                        count: 0
                    },

                    "Non-Drinker": {
                        filter_name: "non_drinker",
                        active: false,
                        count: 0
                    },

                    "Occasional Drinker": {
                        filter_name: "occasional_drinker",
                        active: false,
                        count: 0
                    },

                    "Unknown": {
                        filter_name: "unknown",
                        active: false,
                        count: 0
                    },

                    "No Data": {
                        filter_name: "na",
                        active: false,
                        count: 0
                    }
                }
            ),

            activeCount: 0
        };

        this.aggregates = {
            'sample.patient.alcohol_exposure_intensity': 'count'
        };
    }


    /*
     * Get the selected alcohol filters from the URL
     */
    static getFiltersFromQS(qsObj, oldfilters) {

        const qsAlcoholFilter =
            ('alcohol_exposure_intensity' in qsObj)
                ? _.split(
                    qsObj.alcohol_exposure_intensity,
                    '_'
                )
                : [];

        return _.reduce(
            oldfilters,
            (res, filterProps, alcohol_exposure_intensity) => {

                res[alcohol_exposure_intensity] = {
                    ...filterProps,

                    active:
                        _.indexOf(
                            qsAlcoholFilter,
                            urlify(alcohol_exposure_intensity)
                        ) >= 0
                };

                return res;
            },
            {}
        );
    }


    static getDerivedStateFromProps(newprops, oldstate) {

        const current_qs = qs.parse(
            newprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const newfilters =
            AlcoholFilter.getFiltersFromQS(
                current_qs,
                oldstate.filters
            );

        return {
            filters: newfilters,

            activeCount:
                _.filter(
                    newfilters,
                    'active'
                ).length
        };
    }


    /*
     * Add the selected alcohol filters to the API request.
     */
    updateAPIURL(current_api_qs, newlistprops) {

        const new_qs = qs.parse(
            newlistprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const qsAlcoholFilter =
            AlcoholFilter.getFiltersFromQS(
                new_qs,
                this.state.filters
            );

        const apiAlcoholFilters = _.map(
            _.filter(
                _.toPairs(qsAlcoholFilter),
                ([alcohol_exposure_intensity, filterProps]) => {
                    return filterProps.active;
                }
            ),

            ([alcohol_exposure_intensity, filterProps]) => {
                return filterProps.filter_name;
            }
        );


        const filter_qs = {
            name: "sample",
            op: "has",
            val: {
                name: "patient",
                op: "has",
                val: {
                    name: "alcohol_exposure_intensity",
                    op: "in",
                    val: apiAlcoholFilters
                }
            }
        };


        if (apiAlcoholFilters.length > 0) {

            current_api_qs.filter = [
                ...(current_api_qs.filter || []),
                filter_qs
            ];
        }


        return _.merge(
            current_api_qs,
            {
                agg: this.aggregates
            }
        );
    }


    /*
     * Convert the aggregate response into the values
     * displayed next to each checkbox.
     */
    processResponse(response) {

    const resp_agg = this.get_agg_values(response);
    const agg_field = _.keys(this.aggregates)[0];

    if (!resp_agg) {
        return;
    }

    /*
     * Get the count aggregation.
     *
     * This follows the same structure your original filter
     * was using, rather than assuming a different response shape.
     */
    const counts = _.get(
        resp_agg,
        [agg_field, this.aggregates[agg_field]],
        {}
    );

    console.log(
        'Alcohol aggregate:',
        resp_agg
    );

    console.log(
        'Alcohol counts:',
        counts
    );


    /*
     * Keep all of the existing filter definitions so that
     * options don't disappear just because their count is 0.
     */
    const newfilters = _.mapValues(
        this.state.filters,
        (filterProps) => ({
            ...filterProps,
            count: 0
        })
    );


    /*
     * Map API values to the labels used in the UI.
     */
    _.forEach(
        counts,
        (count, value) => {

            let label = value;


            /*
             * API -> UI mappings
             */
            if (
                value === 'NA' ||
                value === 'na'
            ) {
                label = 'No Data';
            }


            /*
             * Sometimes the API may return these with
             * slightly different capitalisation.
             */
            if (
                value === 'Drinker' ||
                value === 'drinker'
            ) {
                label = 'Drinker';
            }

            else if (
                value === 'Heavy Drinker' ||
                value === 'heavy_drinker'
            ) {
                label = 'Heavy Drinker';
            }

            else if (
                value === 'Lifelong Non-Drinker' ||
                value === 'lifelong_non_drinker'
            ) {
                label = 'Lifelong Non-Drinker';
            }

            else if (
                value === 'Non-Drinker' ||
                value === 'non_drinker'
            ) {
                label = 'Non-Drinker';
            }

            else if (
                value === 'Occasional Drinker' ||
                value === 'occasional_drinker'
            ) {
                label = 'Occasional Drinker';
            }

            else if (
                value === 'Unknown' ||
                value === 'unknown'
            ) {
                label = 'Unknown';
            }


            /*
             * Only update a known UI option.
             */
            if (
                Object.prototype.hasOwnProperty.call(
                    newfilters,
                    label
                )
            ) {

                newfilters[label] = {
                    ...newfilters[label],
                    count: Number(count) || 0
                };
            }
        }
    );


    this.setState({
        filters: newfilters
    });
}


    toggleCheckbox(event) {

        const alcohol_exposure_intensity =
            urlify(event.target.name);


        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        let alcoholFilter =
            ('alcohol_exposure_intensity' in current_qs)
                ? _.split(
                    current_qs.alcohol_exposure_intensity,
                    '_'
                )
                : [];


        if (event.target.checked) {

            /*
             * Don't add duplicates.
             */
            if (
                !alcoholFilter.includes(
                    alcohol_exposure_intensity
                )
            ) {
                alcoholFilter.push(
                    alcohol_exposure_intensity
                );
            }

        } else {

            alcoholFilter =
                alcoholFilter.filter(
                    (item) =>
                        urlify(item) !==
                        alcohol_exposure_intensity
                );
        }


        current_qs.alcohol_exposure_intensity =
            alcoholFilter.length > 0
                ? _.join(
                    alcoholFilter.sort(),
                    '_'
                )
                : undefined;


        /*
         * Reset pagination when a filter changes.
         */
        current_qs.page = undefined;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    toggleCollapse() {

        this.setState({
            isOpen: !this.state.isOpen
        });
    }


    renderAlcoholCheckboxes() {

        if (_.isUndefined(this.state.filters)) {
            return null;
        }


        let active = [];
        let inactive = [];


        _.map(
            _.toPairs(this.state.filters),
            ([key, filterProps]) => {

                const count =
                    Number(filterProps.count) || 0;


                const cb = (
                    <FormGroup
                        check
                        key={key}
                    >

                        <Input
                            type="checkbox"
                            name={key}
                            onChange={this.toggleCheckbox}
                            checked={!!filterProps.active}
                        />

                        {' '}

                        <Label
                            className="ml-4 mt-1"
                            check
                        >

                            {key}

                            <span className="secondary">
                                {' '}({count})
                            </span>

                        </Label>

                    </FormGroup>
                );


                if (filterProps.active) {
                    active.push(cb);
                } else {
                    inactive.push(cb);
                }
            }
        );


        /*
         * Show active filters first, followed by enough
         * inactive filters to make five visible.
         */
        if (
            active.length < 5 &&
            active.length + inactive.length > 0
        ) {

            active = active.concat(
                inactive.splice(
                    0,
                    5 - active.length
                )
            );
        }


        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }


    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    render() {

        return (
            <Card className="mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline w-50">
                        Alcohol Status
                    </div>


                    <div className="d-inline-block">

                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount + ' active'}
                            </strong>
                        )}

                    </div>


                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>


                <Collapse
                    isOpen={this.state.isOpen}
                >

                    <CardBody>

                        {this.renderAlcoholCheckboxes()}

                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(AlcoholFilter);